function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoPhotoCropperTemplate = require('./saito-photo-cropper.template');
var SaitoOverlay = require('../saito-overlay/saito-overlay');
var Cropper = require('cropperjs');
var SaitoPhotoCropper = /*#__PURE__*/function () {
  function SaitoPhotoCropper(app, mod) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'banner';
    _classCallCheck(this, SaitoPhotoCropper);
    this.app = app;
    this.mod = mod;
    this.type = type;
    this.overlay = new SaitoOverlay(app, mod);
    this.callbackAfterCrop = null;
  }
  return _createClass(SaitoPhotoCropper, [{
    key: "render",
    value: function render(image) {
      this.image = image;
      try {
        this.overlay.show(SaitoPhotoCropperTemplate(this.app, this.mod));
        this.attachEvents();
      } catch (error) {
        console.error('Failed to render SaitoPhotoCropper:', error);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      try {
        var imgElement = document.getElementById('imageToCrop');
        if (!imgElement) {
          throw new Error('Image element not found.');
        }
        imgElement.src = this.image;
        var cropper = new Cropper(imgElement, {
          aspectRatio: this.getAspectRatio(),
          crop: function crop(event) {
            console.log("Crop X: ".concat(event.detail.x));
            console.log("Crop Y: ".concat(event.detail.y));
            console.log("Crop Width: ".concat(event.detail.width));
            console.log("Crop Height: ".concat(event.detail.height));
          }
        });
        var cropButton = document.getElementById('cropButton');
        if (!cropButton) {
          throw new Error('Crop button not found.');
        }
        cropButton.style.display = 'block';
        cropButton.onclick = function () {
          try {
            var croppedCanvas = cropper.getCroppedCanvas();
            if (_this.callbackAfterCrop) {
              _this.callbackAfterCrop(croppedCanvas.toDataURL());
            } else {
              throw Error('No callback on crop ');
            }
            cropper.destroy();
            imgElement.style.display = 'none';
            cropButton.style.display = 'none';
          } catch (cropError) {
            console.error('Failed to crop image:', cropError);
          }
        };
      } catch (error) {
        console.error('Failed to attach events or initialize cropper:', error);
      }
    }
  }, {
    key: "getAspectRatio",
    value: function getAspectRatio() {
      if (this.type === 'banner') {
        return 3;
      }
      return 3;
    }
  }]);
}();
module.exports = SaitoPhotoCropper;